import { CodepenCircleOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import * as React from "react";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import styled from "styled-components";

import Alist from "../pages/group";
import Adate from "../pages/date";
import Adetail from "../pages/detail";
import PageHeader from "../comp/pageheader";
import DonateList from "../pages/donatelist";
import DonateDetail from "../pages/donatedetail";

import MissionList from "../pages/mission";

const MainLayoutDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .ascontent {
    display: flex;
    flex-direction: row;
    flex: 1;
    height: calc(100vh - 60px);
    .leftmenu {
      width: 150px;
      height: calc(100vh - 60px);
      border-right: 1px solid #eee;
    }
  }
`;
const ContentLayout = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;

const MainLayout: React.FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loc = location.pathname;
  var selk = "";
  if (loc.indexOf("donate") > 0) {
    selk = "donate";
  } else if (loc.indexOf("mission") > 0) {
    selk = "mission";
  } else {
    selk = "group";
  }

  const clickMenu = (c: string) => {
    navigate(c);
  };

  const items = [
    {
      label: <span onClick={() => clickMenu("/group")}>我的周会</span>,
      key: "group",
      icon: <CodepenCircleOutlined />,
    },
    // {
    //   label: <span onClick={() => clickMenu("/group/donate")}>乐捐情况</span>,
    //   key: "donate",
    //   icon: <CodepenCircleOutlined />,
    // },
    {
      label: <span onClick={() => clickMenu("/group/mission")}>日志导出</span>,
      key: "mission",
      icon: <CodepenCircleOutlined />,
    },
  ];

  return (
    <MainLayoutDiv>
      <PageHeader />
      <div className="ascontent">
        <div className="leftmenu">
          <Menu
            items={items}
            mode="inline"
            style={{ width: 149 }}
            selectedKeys={[selk]}
            className="mt15"
          ></Menu>
        </div>
        <ContentLayout>
          <Routes>
            <Route path="/" element={<Alist />}></Route>
            <Route path="date" element={<Adate />}></Route>
            <Route path="detail" element={<Adetail />}></Route>
            <Route path="donate" element={<DonateList />}></Route>
            <Route path="donatedetail" element={<DonateDetail />}></Route>
            <Route path="mission" element={<MissionList />}></Route>
          </Routes>
        </ContentLayout>
      </div>
    </MainLayoutDiv>
  );
};

export default MainLayout;
